document.addEventListener("DOMContentLoaded", function() {
  const BASE_API = "https://phpstack-1493770-5702411.cloudwaysapps.com/kleberfarm-dev";
  const btn = document.getElementById("custom-external-post");
  const fileInput = document.getElementById("artwork-upload");
  const errorBox = document.querySelector(".custom-error-msg");
  const productJsonEl = document.getElementById("ProductJson");
  const productShapeEl = document.getElementById("Product_metafield");
  const customerEmail = window.customerEmail ? window.customerEmail : null;
  const customerId = window.customerId ? window.customerId : null;
  let pageUrl = window.location.href;

  const productData = JSON.parse(productJsonEl.textContent);
  const productShapeData = productShapeEl.textContent.trim();
// console.log(productShapeData, "<< productShapeData >>>");

  function getCurrentVariant() {
    const variantIdInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const variantId = variantIdInput?.value;
    return productData.variants.find(v => v.id == variantId);
  }

  function validateCustomOptions() {
    let valid = true;
    let errors = [];

    const sizeWrapper = document.querySelector(".custom-div");
    const widthInput = sizeWrapper?.querySelector(".width-type");
    const heightInput = sizeWrapper?.querySelector(".height-type");
    // const sizeIsCustom = sizeWrapper?.classList.contains("checked");
    const sizeIsCustom = sizeWrapper?.parentNode.classList.contains('active');

    const qtyWrapper = document.querySelector(".custom-qty-input");
    const qtyInput = qtyWrapper?.querySelector(".quantity-custom-input");
    const qtyIsCustom = qtyWrapper?.classList.contains("checked");
    // const qtyIsCustom = qtyWrapper?.parentNode.classList.contains('active');


    if (sizeIsCustom) {
      const widthVal = parseFloat(widthInput?.value);
      const heightVal = parseFloat(heightInput?.value);
      if (!widthInput.value || !heightInput.value) {
        valid = false;
        errors.push("Bitte geben Sie für die Größe sowohl Breite als auch Höhe ein.");
        sizeWrapper?.classList.add("error");
      } else if (widthVal < 4 || heightVal < 4 || widthVal > 15 || heightVal > 15) {
        valid = false;
        errors.push("Bitte geben Sie eine gültige Breite und Höhe ein (Wert muss mindestens 4 und darf nicht mehr als 15 betragen)");
        sizeWrapper?.classList.add("error");
      } else {
        sizeWrapper?.classList.remove("error");
      }
    }

    if (qtyIsCustom) {
      const qtyInputVal = parseFloat(qtyInput?.value);
      if (!qtyInput.value) {
        valid = false;
        errors.push("Bitte geben Sie eine Menge ein");
        qtyWrapper?.classList.add("error");
      } else if (qtyInputVal % 1 !== 0) {
        valid = false;
        errors.push("Bitte geben Sie eine gültige Zahl ein (kein Dezimalwert)");
        qtyWrapper?.classList.add("error");
      } else if (qtyInputVal < 50 || qtyInputVal > 100000) {
        valid = false;
        errors.push("Bitte geben Sie eine gültige Menge ein (darf nicht weniger als 50 und nicht mehr als 100.000 sein).");
        qtyWrapper?.classList.add("error");
      } else {
        qtyWrapper?.classList.remove("error");
      }
    }

    // const errorBox = document.querySelector(".custom-error-msg");
    if (errorBox) {
      if (errors.length > 0) {
      const errorHTML = `
        <ul>
          ${errors.map(err => `<li>${err}</li>`).join('')}
        </ul>`;
      errorBox.innerHTML = errorHTML;
      errorBox.style.display = "block";
      } else {
        errorBox.textContent = "";
        errorBox.style.display = "none";
      }
    }
    return valid;
  }

  btn.addEventListener("click", function(e) {
    if (!validateCustomOptions()) {
      e.preventDefault(); 
      return;
    }
    const currentVariant = getCurrentVariant();
    if (!currentVariant) return console.error("Variant not found");

    // if (!currentVariant) {
    //   console.error("Variant not found");
    //   return;
    // }

    btn.disabled = true;
    btn.dataset.originalText = btn.innerText;
 
    const file = fileInput.files[0];
    // if (!file) {
    //   if (errorBox) {
    //     errorBox.innerText = "Please upload your artwork before continuing.";
    //   }
    //   btn.disabled = false;
    //   // btn.innerText = btn.dataset.originalText;
    //   return; 
    // }

    let productCode = null;
    if (!productJsonEl) return console.error("Product JSON not found.");

    // if (!productJsonEl) {
    //   console.error("Product Json not found.");
    //   return;
    // }
    // const productData = JSON.parse(productJsonEl.textContent);
        
    const handle = productData.handle || "";
    if(handle.includes("white") || handle.includes("sticker-sheet") ){ productCode = "kleberfarm-die-cut-vinyl-api" }
    // if(handle.includes("sticker-sheet")){ productCode = "kleberfarm-die-cut-vinyl-api" }
    if(handle.includes("clear")){ productCode = "kleberfarm-die-cut-clear-api" }
    if(handle.includes("holographic")){ productCode = "kleberfarm-die-cut-holo-api" }

    let order_id = Math.floor(Math.random() * 900_000_000_000_000) + 100_000_000_000_000;

    function getSelectedQuantity() {
      let quantity = 1; // default fallback

      // 1️⃣ Check for selected radio button inside quantity-list
      const $selectedRadio = $('.quantity-list input[type="radio"]:checked');
      if ($selectedRadio.length) {
        quantity = parseInt($selectedRadio.val(), 10) || 1;
      } else {
        // 2️⃣ Check custom input field
        const $customInput = $('.quantity-list .quantity-custom-input');
        if ($customInput.length) {
          const val = parseInt($customInput.val(), 10);
          if (!isNaN(val) && val > 0) {
            quantity = val;
          }
        }
      }

      return quantity;
    }



    let sizeOption, sizeQty, finishOption, widthMM, heightMM, newProductShape;
    productData.options.forEach((optName, index) => {
      const value = currentVariant[`option${index + 1}`];
      if (!value) return;

      const selectedQty = getSelectedQuantity();
      console.log(selectedQty, "<<< selected quantity");

      const key = optName.toLowerCase();
      if (value) {
        if (key === "size") { sizeOption = value; }
        if (key === "quantity") { sizeQty = selectedQty; }
        if (key === "finish") { 
          finishOption = value 
        } else{
          finishOption = "Matte" 
        }

        if (key === "cut") { 
          if(value.toLocaleLowerCase().includes("benutzerdefinierte") || value.toLocaleLowerCase().includes("die-cut")) newProductShape = null 
          if(value.toLocaleLowerCase().includes("kreis") || value.toLocaleLowerCase().includes("circle")) newProductShape = "circle" 
          if(value.toLocaleLowerCase().includes("oval") || value.toLocaleLowerCase().includes("ellipse")) newProductShape = "ellipse" 
          if(value.toLocaleLowerCase().includes("rechteck") || value.toLocaleLowerCase().includes("rectangle")) newProductShape = "rectangle" 
          if(value.toLocaleLowerCase().includes("quadrat") || value.toLocaleLowerCase().includes("square")) newProductShape = "square" 
         }
      }
    });

    console.log(newProductShape, "<, newProductShape");
    console.log(sizeQty, "<, sizeQty");

    if(sizeOption == "Custom size" || sizeOption == "custom size" ){
      console.log(sizeOption, "<, sizeOption if");
      // widthMM = $('.custom-div input.width-type').val();
      // heightMM = $('.custom-div input.height-type').val();
      widthMM = document.querySelector(".custom-div .width-type")?.value || 0;
      heightMM = document.querySelector(".custom-div .height-type")?.value || 0;
    } else if (sizeOption) {
      console.log(sizeOption, "<, sizeOption Elseif");
      if (sizeOption.includes("*")) {
      console.log(sizeOption, "<, sizeOption Elseif if include *");

        const parts = sizeOption.split("*").map(p => p.trim());
        if (parts.length === 2) {
          widthMM = parseFloat(parts[0]);
          heightMM = parseFloat(parts[1]);
        }
      } else if (sizeOption.match(/(\d+)\s*x\s*(\d+)\s*cm/i)) {
      console.log(sizeOption, "<, sizeOption Elseif else if include 10 * 10");

        // Case: "20 x 30 cm"
        const match = sizeOption.match(/(\d+)\s*x\s*(\d+)\s*cm/i);
        widthMM = parseInt(match[1], 10);
        heightMM = parseInt(match[2], 10);

      } else if (sizeOption.match(/\((\d+)\s*cm\)/i)) {
      console.log(sizeOption, "<, sizeOption Elseif else if include 10");

        // NEW CASE: "S(5cm)"
        const match = sizeOption.match(/\((\d+)\s*cm\)/i);
        if (match) {
          widthMM = parseInt(match[1], 10);
          heightMM = parseInt(match[1], 10);
        }
      } else if (sizeOption.match(/^\s*(\d+)\s*cm\s*$/i)) {
        console.log(sizeOption, "< plain number with cm");

        // NEW CASE: "S 5cm"
        const match = sizeOption.match(/^\s*(\d+)\s*cm\s*$/i);
        widthMM = parseInt(match[1], 10);
        heightMM = parseInt(match[1], 10);
      }
            
      // else if (sizeOption.includes("(") || sizeOption.includes("cm")) {
      //   // const match = sizeOption.match(/\((\d+)\s*x\s*(\d+)cm\)/i);
      //   const match = sizeOption.match(/(\d+)\s*x\s*(\d+)\s*cm/i);
      //   if (match) {
      //     widthMM = parseInt(match[1], 10);
      //     heightMM = parseInt(match[2], 10);
      //   }
      // }
    }


    if(sizeQty == "Custom" || sizeQty == "custom" ){
      sizeQty = $(".custom-qty-input.checked .quantity-custom-input").val()
    }

    console.log(sizeQty, "sizeQty after Custom val")

   
    // const shop_url = window.shopUrl + '/cart'
    const shop_url = window.shopUrl + '/products/' + productData.handle + '?variant=' + currentVariant.id;
    console.log(shop_url, "<<< shop_url");

    // finishing : finishOption,
    let finishing = "Matte";


    const basePayload  = {
      product_id: productData.id,
      widthMM : widthMM,
      heightMM : heightMM,
      packSize : sizeQty,
      finishing : finishOption,
      productShape: productShapeData,
      newProductShape : newProductShape,
      quantity: 1,
      orderId: order_id,
      productCode: productCode,
      returnUrl: shop_url,
      customerEmail: customerEmail,
      customerId: customerId,
    };

    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        const payload = {
          ...basePayload,
          image_name: file.name,
          image_url: e.target.result
        };

        // sendData(payload);
        sendData(payload, currentVariant, sizeOption, widthMM, heightMM, sizeQty); 
      };
      reader.readAsDataURL(file);
    } else {
      const payload = {
        ...basePayload,
        image_name: null,
        image_url: null
      };
    // sendData(payload);
    sendData(payload, currentVariant, sizeOption, widthMM, heightMM, sizeQty); 
    }   

  });

  function sendData(payload, currentVariant, sizeOption, widthMM, heightMM, sizeQty) {
    // console.log("Variant:", currentVariant);
    console.log("Final Payload:", payload);

    fetch(`${BASE_API}/kleberfarm_post.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then(res => {
      return res.text();
    })
    .then(text => {
      let response;
      try {
        response = JSON.parse(text); 
      } catch (e) {
        console.warn("⚠️ Response is not JSON, returning raw text.");
        response = { raw: text }; 
      }
      const oldError = document.querySelector(".custom-error-msg");

      if (response.error) {
        let errMsg = document.querySelector(".custom-error-msg");
        let errorMsg = response.error;

        const rawData = JSON.parse(response.raw);
        if (rawData?.errorMessage) {
          errorMsg = rawData.errorMessage;
        }
        
        if (errMsg) {
          errMsg.innerText = errorMsg;
        }
        btn.disabled = false;
        errMsg.style.display = "block";
      }
       else {
        console.log("✅ Final parsed response:", response);

        if (response.id) {
          localStorage.setItem('designerId', response.id);
          sessionStorage.setItem('designerIdSession', response.id);
        }

        const iframeUrl = "https://designer.antigro.com/de?clientDesignId=" + response.id ;
        const popup = document.getElementById("designPopup");
        const iframe = document.getElementById("antigroDesignerIframe");
        const closeBtn = document.getElementById("customCloseBtn");

        // // set iframe url
          iframe.src = iframeUrl;
          popup.style.display = "block";
          popup.classList.add("activePopup");

          //  closeBtn.onclick = function () {
          //    popup.style.display = "none";
          //    iframe.src = ""; 
          //    btn.disabled = false;
          //    // btn.innerText = btn.dataset.originalText;
          //    if (document.querySelector(".custom-error-msg")) {
          //      document.querySelector(".custom-error-msg").innerText = "";
          //     }
          //   clearInterval(intervalId);
          //   console.log('closeBtn.onclick  as clearInterval');
          // };         

          // close popup on outside click
          // window.onclick = function (event) {
          //   if (event.target === popup) {
          //     popup.style.display = "none";
          //     iframe.src = "";
          //     btn.disabled = false; 
          //   }
          // };

          // ---------- Start
          const intervalTime = 1000;
          let intervalId;
          let timeoutId;

          function checkThumbnail() {
            // Get the stored ID from localStorage
            const storedDesignId = localStorage.getItem('designerId');
            const storedDesignIdSession = sessionStorage.getItem('designerIdSession');
            let draftOrderId = localStorage.getItem('draftOrderId');

            console.log(storedDesignId, "<<< storedDesignId >??????????????????????????????");
            
            if (!storedDesignId) return;
            if (!draftOrderId){
              draftOrderId = null;
            }
            
            console.log(draftOrderId, "draftOrderId")
            fetch(`${BASE_API}/kleberfarm_get.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ designId: storedDesignIdSession, draftOrderId: draftOrderId })
            })
            .then(res => res.json())
            .then(data => {
              console.log(data, "<<< === data");
              let thumbUrl = data?.projectParameters?.length > 0 && data.projectParameters[0]?.thumbUrl ? data.projectParameters[0].thumbUrl : '';
              let project_parameter_id = data?.projectParameters?.length > 0 && data.projectParameters[0]?.id ? data.projectParameters[0].id : '';

              let project_parameter_height = data?.projectParameters?.length > 0 && data.projectParameters[0]?.heightCm ? data.projectParameters[0].heightCm : '';
              let project_parameter_width = data?.projectParameters?.length > 0 && data.projectParameters[0]?.widthCm ? data.projectParameters[0].widthCm : '';

              console.log(data.status, "data.projectParameters[0]?.status")
              
              if (data.projectParameters && thumbUrl) {
                document.body.classList.add('has-thumbnail');
                popup.style.display = "none";
                popup.classList.remove("activePopup");

                const params = new URLSearchParams(window.location.search);
                const variantId = params.get('variant') || currentVariant.id;
                var currentUrl = window.location.href;


                // Create base properties object
                let item_properties = {
                  "Design Id": storedDesignIdSession,
                  "Product Id": project_parameter_id,
                  // "widthMM": project_parameter_width.toFixed(2),
                  // "heightMM": project_parameter_height.toFixed(2),
                  "Breite in cm": project_parameter_width.toFixed(2),
                  "Höhe in cm": project_parameter_height.toFixed(2),
                  // "sizeQty": sizeQty,
                  "Menge": sizeQty,
                  "Thumbnail URL": thumbUrl,
                };

                // // Add size properties if custom size is selected
                // if (sizeOption && (sizeOption.toLowerCase() === "custom size")) {
                //   item_properties = {
                //     ...item_properties,  // Spread the existing properties
                //     "widthMM": widthMM,
                //     "heightMM": heightMM,
                //     "sizeQty": sizeQty
                //   };
                // }

                // console.log(sizeQty, "<< currentVariant.id")

                if (currentUrl.indexOf(variantId) !== -1 || data.status === 'ACCEPTED') {
                  if (variantId) {
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                      },
                      body: JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        properties: item_properties
                      })
                    })
                    .then(res => res.json())
                    // .then(data => {
                    //   // window.location.href = '/cart';
                    //   setTimeout(() => window.location.href='/cart', 200);
                    // })
                    .then(() => setTimeout(() => window.location.href='/cart', 800))
                    .catch(err => console.error('Error adding to cart:', err));
                  } else {
                    console.warn('No Thumbnail ID found in response');
                  }
                }
                // document.body.dataset.thumbnailUrl = data.projectParameters[0].thumbUrl;
                  
                if (data.status === 'ACCEPTED' && intervalId) {
                  clearInterval(intervalId);
                  intervalId = null;
                  console.log('Interval cleared as status is ACCEPTED');
                }
              }
            })
            .catch(error => {
              console.error('Error fetching design data:', error);
            });
          }
          setTimeout(() => {
              checkThumbnail();
              intervalId = setInterval(checkThumbnail, intervalTime);
          }, 15000);

          // ---------- END

          // stop interval when user clicks Close button
          closeBtn.addEventListener("click", function () {
            if (intervalId) {
              clearInterval(intervalId);
              intervalId = null;
            }
            if (document.querySelector(".custom-error-msg")) {
               document.querySelector(".custom-error-msg").innerText = "";
            }
            popup.style.display = "none";
            iframe.src = "";
            btn.disabled = false;
            popup.classList.remove("activePopup");
          });


        // if(window.location.href.includes('circle-sticker-white')){
        // } else{
        //   if (response.id) {
        //     window.location.href = "https://designer-test.antigro.com/en?clientDesignId=" + response.id;
        //     // window.location.hash = `clientDesignId=${response.id}`;
        //   }
        // }
      }
      // console.log("✅ Final parsed response:", response);
    })
    .catch(err => {
      console.error("Error sending data:", err);
    });
  }
});

// Select all relevant inputs (width, height, and custom quantity)
const customInputs = document.querySelectorAll(
  '.width-type, .height-type, .quantity-custom-input'
);
customInputs.forEach(input => {
  input.addEventListener('click', e => e.stopPropagation());
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const btn = document.getElementById('custom-external-post');
      if (btn) {
        btn.click();
        console.log(`✅ Triggered custom button from ${input.className}`);
      } else {
        console.warn('⚠️ custom-external-post button not found');
      }
    }
  });
});






// // Check URL if contains the Client id starts
// $(document).ready(function () {
//   const params = new URLSearchParams(window.location.search);
//   const variantId = params.get('variant');
//   const clientDesignId = params.get('clientDesignId');

//   console.log(clientDesignId, "<< clientDesignId")

//   var keyword = "&clientDesignId"; 
//   var currentUrl = window.location.href;

//   if (currentUrl.indexOf(keyword) !== -1) {
//     if (variantId) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1,
//           properties: {
//           "Design Id": clientDesignId,
//           }
//         })
//       })
//       .then(res => res.json())
//       .then(data => {
//         // console.log('Added to cart:', data);
//         window.location.href = '/cart';
//       })
//       .catch(err => console.error('Error adding to cart:', err));
//     } else {
//       console.warn('No variant ID found in the URL');
//     }
//   }
// });



